import { useContext } from 'react';
import { IOwnEndorsementContext, OwnEndorsementContext } from '../contexts';

export const useOwnEndorsements = (): IOwnEndorsementContext => {
  return useContext(OwnEndorsementContext);
};
